import React from 'react'
import PropTypes from 'prop-types'
// import './RegisterForm.css'

class CheckBox extends React.Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (e) {
    this.props.onChange({
      stateProp: this.props.stateProp,
      value: e.target.checked
    })
  }

  render () {
    const { label, value, ok, marginTop } = this.props
    return (
      <div className='ua-in-co ua-chb' style={marginTop ? {marginTop: marginTop} : null}>
        <input type='checkbox' checked={value} onChange={this.handleChange} />
        <label className={!ok ? 'ua-ex-r' : null}>{label}</label>
      </div>
    )
  }
}

CheckBox.propTypes = {
  label: PropTypes.element,
  value: PropTypes.bool,
  stateProp: PropTypes.string,
  onChange: PropTypes.func,
  ok: PropTypes.bool,
  marginTop: PropTypes.string
}

export default CheckBox



// WEBPACK FOOTER //
// ./src/components/UserAccount/RegisterFormCheckBox.js